import { get, post, put, del } from './api';
import { API_ENDPOINTS } from './config';
import { Task } from './task';

// 文件夹信息
export interface Folder {
  folderId: string;
  name: string;
  description?: string;
  sortOrder: number;
  taskCount: number;
  createdAt?: string;
}

// 获取文件夹列表
export async function getFolderList(): Promise<Folder[]> {
  const response = await get<Folder[]>(API_ENDPOINTS.FOLDER.LIST);
  return response.data;
}

// 创建文件夹
export async function createFolder(name: string, description?: string): Promise<{ folderId: string; name: string }> {
  const response = await post<{ folderId: string; name: string }>(
    API_ENDPOINTS.FOLDER.CREATE,
    { name, description }
  );
  return response.data;
}

// 重命名文件夹
export async function renameFolder(folderId: string, name: string): Promise<Folder> {
  const response = await put<Folder>(`${API_ENDPOINTS.FOLDER.RENAME}/${folderId}/rename`, { name });
  return response.data;
}

// 删除文件夹
export async function deleteFolder(folderId: string) {
  const response = await del(`${API_ENDPOINTS.FOLDER.DELETE}/${folderId}`);
  return response.data;
}

// 移动任务到文件夹
export async function moveTaskToFolder(taskId: string, folderId: string | null) {
  const response = await put(API_ENDPOINTS.FOLDER.MOVE_TASK, { taskId, folderId });
  return response.data;
}

// 获取文件夹内的任务
export async function getTasksByFolder(folderId: string): Promise<Task[]> {
  const response = await get<Task[]>(`${API_ENDPOINTS.FOLDER.TASKS}/${folderId}/tasks`);
  return response.data;
}
